export const GROWTH_WEBSITE_HEALTH_META = {
  eyebrow: 'SEO · Website Audit',
  titleLead: 'Website',
  titleAccent: 'health report',
  description:
    "ELVA scanned your website and found issues that are costing you patients. Each issue explains the problem in plain English, how it's affecting your practice, and what needs to be fixed.",
  scoreLabel: 'Health score',
  scoreTitle: 'Your website health score',
  revenuePerPatient: 350,
  ctaTitle: 'Need help fixing these issues?',
  ctaDescription:
    'Share this report with your web developer, or the ELVA team can fix most of these for you. Critical issues should be addressed first — they have the biggest impact on patient acquisition.',
  footerScanNote: 'Last scanned Apr 8, 2026 · smiledentaldowntown.com · 34 pages analyzed',
  footerRescanNote: 'ELVA re-scans your website weekly',
  goodPassingNote:
    'No action needed — this check is passing. ELVA re-verifies it on every weekly scan.',
} as const;
